/**
 * Retrieves the query parameters added to the URL. These query params
 * can be on the location hash or the search.
 * @param {boolean} hash search on hashbang instead of the query string
 * @return {Object} with param name as key and param value as value
 */
window.getQueryParams = function (hash) {
    var params = {};

    var hashParts = window.location[hash ? 'hash' : 'search'].split('?');
    if (hashParts.length > 1) {
        var query = hashParts[1], forEach = angular.forEach;

        forEach(query.split('&'), function (param) {
            var p = param.split('=');
            params[p[0]] = p[1];
        });
    }

    return params;
};

(function (upp, window, $UPP) {
    'use strict';

    upp.config(function() {
        // Use the window protocol (http or https) for all requests
        var proto = window.location.protocol;
        $UPP.URL_UPPLICATION_REST_SERVICE = $UPP.URL_UPPLICATION_REST_SERVICE
            .replace('http:', proto.indexOf('http') === -1 ? 'http:' : proto);
    })

    /*
     * ROUTE CONFIG
     * */
    upp.config(['$routeProvider',
        function ($routeProvider) {
            var debug = window.location.search.indexOf('debug=true') !== -1;

            function ModuleIsActivatedResolver(moduleKey) {
                var self = this;
                self.module = moduleKey;
                var resolver = function (configService) {
                    return debug || configService.isAnActiveModule(self.module);
                };
                resolver.$inject = ['config'];
                this.resolver = resolver;
            }

            /***
             *  Returns an instance of a resolver (based on promises) that will check if a module is active so routes for that module are available.
             *
             * @method moduleIsActivated
             * @param name Key of the module to check
             * @return {ModuleIsActivatedResolver} Returns a new instance of the resolver ModuleIsActivatedResolver
             */
            var moduleIsActivated = function (name) {
                return new ModuleIsActivatedResolver(name);
            };

            $routeProvider.ResolverFactory = {
                moduleIsActivated: moduleIsActivated
            };

            $routeProvider
                .when('/token/:token', {
                    templateUrl: require('app/plugins/login/templates/token.html'),
                })
                .when('/password/change/:token', {
                    template: '<div ng-controller="upp.plugins.login.ChangePasswordCtrl"></div>'
                })
                .when('/', {
                    templateUrl: require('./templates/home.html'),
                })
                .otherwise({
                    redirectTo: '/'
                });
        }]);

    //EXCEPTION FACTORY
    upp.factory('exception', function () {
        function CustomError(type, msg) {
            this.type = type;
            this.msg = msg;
        }

        var init = function (type, msg) {
            return new CustomError(type, msg);
        };

        var fatal = function (msg) {
            return init("fatal", msg);
        };

        var minor = function (msg) {
            return init("minor", msg);
        };

        return {
            fatal: fatal,
            minor: minor
        };
    });

    /*
     * HTTP CONFIG
     * */
    upp.config(['$httpProvider',
        function ($httpProvider) {
            $httpProvider.defaults.headers.common['X-Requested-With'] = null;

            var params = window.getQueryParams() || {};
            if (params.childupp) {
                $UPP.IDCHILDUPP = Number(params.childupp);
            }

            var ignoreTrialExpired = !!params.dashboard;

            if ($UPP && $UPP && $UPP.IDCHILDUPP && Number($UPP.IDCHILDUPP) > 0) {
                $httpProvider.defaults.headers.common['ChildUpp'] = $UPP.IDCHILDUPP;
            } else {
                $httpProvider.defaults.headers.common['subdomain'] = window.location.host.split('.')[0];
            }

            $httpProvider.defaults.withCredentials = false;
            $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
            if (params.dashboard) {
                $httpProvider.defaults.headers.common['dashboard'] = 'true';
            }
            $httpProvider.defaults.cache = false;

            var pad = function(number) {
                return ("0" + number).slice(-2)
            };

            $httpProvider.interceptors.push(function() {
                return {
                    'request': function(config) {

                        var now = new Date();
                        config.headers['Local-Date'] = now.getFullYear() + "-" + pad(now.getMonth()+1) + "-" + pad(now.getDate()) +
                            "T" + pad(now.getHours()) + ":" + pad(now.getMinutes()) + ":" + pad(now.getSeconds());

                        return config;
                    }
                };
            });

            var interceptor = ['$q', 'utils',
                function ($q, utils) {
                    function success(response) {
                        return response;
                    }

                    function error(response) {
                        if (response && response.data && response.data.errorMessageCode) {
                            response.data.translatedErrorMessage = utils.i18nHttpErrorCode(response.data.errorMessageCode);
                        }
                        return $q.reject(response);
                    }

                    return function (promise) {
                        return promise.then(success, error);
                    }
                }];

            $httpProvider.responseInterceptors.push(interceptor);
        }]);

    /*
     * HASHBANG/HTML5MODE CONFIG
     */
    upp.config(['$locationProvider',
        function ($locationProvider) {
            $locationProvider.hashPrefix('!');
        }]);

    upp.config(['$compileProvider',
        function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|skype|ionic):/);
        }]);

    upp.config(['tmhDynamicLocaleProvider',
        function (tmhDynamicLocaleProvider) {
            // Load the locales into the output output
            tmhDynamicLocaleProvider.localeLocationPattern('vendor/angular-i18n/angular-locale_{{locale}}.js');
        }]);

    /**
     * Handle back button behaviour:
     * * If we are NOT at the root of the app (url hash != #!/)
     *      fallback to default back behaviour
     * * If we are at the root of the app (url hash == #!/) invoke
     *     application exit
     */
    upp.run(function() {
        window.document.addEventListener('deviceready', function() {
            window.document.addEventListener('backbutton', function() {
                // Hash is configured to be prepended by ! on previous config steps
                // so hash, when available, which happens once the angular router has
                // kicked in, will always start with #!.
                var appUrl = window.location.hash.replace(/^#!/, '')
                if (appUrl !== '/')
                    window.navigator.app.backHistory()
                else
                    window.navigator.app.exitApp()
            })
        })
    })

    /*
     * Handle opening app event through a universal link
     * (universal-link: a link to the webapp anywhere else on the device but the app itself).
     */
    upp.run(['urlResolver', 'childuppRuntime', function(urlResolver, childuppRuntime) {
        if (childuppRuntime.isCordova) {
            if (!window.universalLinks) {
                console.warn('No universalLinks global variable found')
                return;
            }
            window.universalLinks.subscribe(null, function(data) {
                urlResolver.open(data.url);
            });
        }
    }]);

    // Intercept route changes to track the user position on the app
    // currentRoute stores the actual route and prevRoute the previous route
    upp.run(['$rootScope', 'storage', 'routeInterceptorService',
        function ($rootScope, storage, routeInterceptorService) {
            $rootScope.$on('$locationChangeStart', function (event, next, current) {
                storage.set('currentRoute', next);
                storage.set('prev.Route', current);

                routeInterceptorService.intercept(next, current);
            });
        }
    ]);

    // Make ng animated work only on elements marked as .animated
    upp.config(['$animateProvider', function($animateProvider) {
        $animateProvider.classNameFilter(/animated/);
    }]);


})(upp, window, $UPP);



// WEBPACK FOOTER //
// ./src/app/common/app-providers-config.js